import axios from "axios";
import { MAIN_API } from "../MAIN_API";
import { changeStateValue } from "../redux/MainReducer";

export const loginAction = (params) => async dispatch => {
    return await axios.post(`${MAIN_API}/login`, params)
    .then(resp=>{
        localStorage.setItem("loginToken", resp?.data?.token)
        dispatch(changeStateValue({name:"user", value: resp?.data?.user}))

        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}

export const getLoginUser=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/user`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"user", value: resp?.data}))
        return "success";
    }).catch(err=>{
        return "error";
    })
}
export const getLanguages=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-language`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"languages", value: resp?.data}))
        return "success";
    }).catch(err=>{
        return "error";
    })
}




export const getAboutData=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-about?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"adminAbouts", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}

export const getFounderAbout=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-about-founder?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"aboutData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getActivities=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-activities?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"adminActivities", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getContent=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-content?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"contents", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getDonates=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-donates?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"donatesData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getFocusAreas=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-focus-areas?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"focusAreasData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getProjects=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-projects?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"projectsData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}
export const getVolunteering=()=>async dispatch => {
    return await axios.get(`${MAIN_API}/admin-volunteering?lang_id=1`, {
        headers:{
            "Authorization":`Bearer ${localStorage.getItem("loginToken")}`
        }
    }).then(resp=>{
        dispatch(changeStateValue({name:"volunteeringData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        console.log(err.response)
        return "error";
    })
}




export const insertNewData=(url, params)=> async dispatch => {
    dispatch(changeStateValue({name: "loader", value:true}))
    return await axios.post(`${MAIN_API}/${url}`, params, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("loginToken")}`}
    }).then(resp=>{
        console.log(resp.data)
        dispatch(changeStateValue({name: "loader", value:false}))
        return "success"
    }).catch(err=>{
        dispatch(changeStateValue({name: "loader", value:false}))
        console.log(err.response)
        return "error"
    })
}
export const deleteData=(url)=> async dispatch => {
    dispatch(changeStateValue({name: "loader", value:true}))
    return await axios.delete(`${MAIN_API}/${url}`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("loginToken")}` }
    }).then(resp=>{
        dispatch(changeStateValue({name: "loader", value:false}))
        return "success"
    }).catch(err=>{
        dispatch(changeStateValue({name: "loader", value:false}))
        console.log(err.response)
        return "error"
    })
}